export default Object.freeze({
    canTransferOwnership: [
        "king", "queen", "owner", "admin"
    ],
    canReceiveOwnership: [
        "king", "queen", "owner", "rook"
    ],
    canLeaveProject: [
        "king", "queen", "rook", "knight", "pawn",
        "user", "admin"
    ],
    canCreateProject: [
        "king", "queen", "rook"
    ],
    canUpdateProject: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canCreateProjectSection: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canChangeProjectAccesibility: [
        "king", "queen", "rook",
        "owner", "admin"
    ],
    canChangeProjectStatus: [
        "king", "queen", "rook",
        "owner", "admin"
    ],
    canDeleteProject: [
        "king", "queen", "rook",
        "owner"
    ],
    canCreateStyleguide: [
        "king", "queen", "rook"
    ],
    canDeleteStyleguide: [
        "king", "queen", "rook",
        "owner"
    ],
    canLeaveStyleguide: [
        "king", "queen", "rook", "knight", "pawn",
        "user", "admin"
    ],
    canUpdateStyleguide: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canChangeStyleguideStatus: [
        "king", "queen", "rook",
        "owner", "admin"
    ],
    canManageScreens: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canManageComponents: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canMoveScreens: [
        "king", "queen", "rook",
        "owner", "admin"
    ],
    canRemoveVersions: [
        "king", "queen",
        "owner", "admin"
    ],
    canManageColors: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canManageTextStyles: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canManageSpacings: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canRemoveNotes: [
        "king", "queen",
        "owner", "admin"
    ],
    canRemoveExtensions: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canManageRemSettings: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canManageWorkflowStatuses: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canCopyBarrel: [
        "king", "queen", "owner", "rook"
    ],
    /**
     * Free plan: Owner
     * Personal plans: Project and styleguide members
     * Organization: Editors and above
     */
    canMoveResources: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ],
    canManageWebhooks: [
        "king", "queen",
        "owner", "admin"
    ],
    canChangePlan: [
        "king", "queen",
        "owner", "admin"
    ],
    canHighlightComponents: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canDisplayGridView: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canManageStorybookIntegration: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canSeeOthersEmail: [
        "king", "queen",
        "owner", "admin"
    ],
    canCreateAnnotation: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canUpdateAnnotation: [
        "king", "queen", "rook",
        "owner", "admin"
    ],
    canRemoveAnnotations: [
        "king", "queen",
        "owner", "admin"
    ],
    canRequestActivityLogs: [
        "king", "queen"
    ],
    canCreateApprovals: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canManageApprovals: [
        "king", "queen", "owner", "admin"
    ],
    canDisplayApprovalsReminderPopup: [
        "king", "queen", "owner", "admin", "rook", "knight"
    ],
    canChangeCommitColor: [
        "king", "queen", "rook", "knight",
        "owner", "admin", "user"
    ],
    canSyncStyleguideLibraryWithFigma: [
        "king", "queen", "owner", "admin", "rook"
    ],
    canCustomizeNoteTypes: [
        "king", "queen", "rook",
        "owner", "admin", "user"
    ]
});
